import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { TextField, Button, Container, Typography, Box, Alert, AlertTitle } from '@mui/material';
import { useCarrito } from '../context/CarritoContext';

const Login = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { setRol, setIdUsuario }= useCarrito();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      
      const response = await fetch(`https://bibliotecadlago.com/login.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        setErrorMessage(data.message || 'Error al iniciar sesión');
        return;
      } else {
        Cookies.set('authToken', data.token, { expires: 1, path: '/' });
        Cookies.set('OtrasMarcas', data.OtrasMarcas, { expires: 30 });
        Cookies.set('VerSucursales', data.VerSucursales, { expires: 30 });
        Cookies.set('IdUsuario', data.IdUsuario, { expires: 30 });
        Cookies.set('PrecioHankook', data.PrecioHankook, { expires: 30 });
        Cookies.set('PedidoExpress', data.PedidoExpress, { expires: 30});
        Cookies.set('Facturacion', data.Facturacion, { expires: 30});
        Cookies.set('Tarjeta', data.Tarjeta, { expires: 30});
        Cookies.set('CampanaExtras', data.CampanaExtras, { expires: 30});
        localStorage.setItem('Encargado', data.Encargado);
        localStorage.setItem('Tarjeta', data.Tarjeta)
        localStorage.setItem('ClaEnlaceMichelin', data.ClaEnlaceMichelin);
        localStorage.setItem('token', data.token);
        localStorage.setItem('Nombre', data.nombre);
        localStorage.setItem('Telefono', data.Telefono);
        localStorage.setItem('Seguimiento', data.Seguimiento);
        localStorage.setItem('Asesor', data.Asesor);
        setRol(data.Rol);
        setIdUsuario(data.IdUsuario);
        setErrorMessage('');
        localStorage.setItem('Salir', false);
        navigate('/inventario.html');
      }
    } catch (error) {
      console.log(error);
      setErrorMessage('Error de conexión con el servidor');
    }
  };


  return (
    <Container maxWidth="xs" sx={{ mt: 5 }}>
      <img src='/logo llantas.png' width={'90%'} alt=''></img>
      <br />
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          alignItems: 'center',
          boxShadow: 3,
          p: 3,
          borderRadius: 2,
        }}
      >
        {errorMessage && (
          <Alert severity="error" onClose={() => setErrorMessage('')}>
            <AlertTitle>Error</AlertTitle>
            {errorMessage}
          </Alert>
        )}
        <Typography variant="h5" gutterBottom sx={{ color: '#CD050F' }}>
          Iniciar sesión
        </Typography>
        <TextField
          label="Correo electrónico o Usuario"
          variant="outlined"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <TextField
          label="Contraseña"
          type="password"
          variant="outlined"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Button
          type="submit"
          variant="contained" color="primary"
          sx={{
            backgroundColor: '#CD050F',
            '&:hover': {
              backgroundColor: '#9b040f',
            },
          }}
          fullWidth>
          Iniciar sesión
        </Button>
      </Box>
    </Container>
  );
};

export default Login;
